module.exports = __webpack_public_path__ + "static/ohnodalle-11667ea945993fb0197ffdc1838cee4a.png";